<template>
  <m-button
    class="active-button"
    :class="{
      'active-button--active': active,
      ['active-button--' + lineColor + '-line']: true,
      ['active-button--' + linePosition + '-line']: true
    }"
    @click="click"
  >
    <slot></slot>
  </m-button>
</template>

<script>
import MButton from '@/components/buttons/MButton'

export default {
  components: { MButton },
  props: {
    active: Boolean,
    resetIfActive: Boolean,
    lineColor: {
      type: String,
      default: 'white'
    },
    linePosition: {
      default: 'bottom',
      validator: function (value) {
        return [ 'top', 'right', 'bottom', 'left' ].indexOf(value) !== -1
      }
    }
  },
  methods: {
    click () {
      if (this.active && this.resetIfActive) return
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.active-button--active { cursor: default; }
.active-button--active:hover { background: none; }
.active-button:before { border-radius: 1px; content: ''; position: absolute; transition: transform .3s; }
.active-button--white-line:before { background: #fff; }
.active-button--blue-line:before { background: #8c9eff; }
.active-button--gold-line:before { background: #d4af37; }
.active-button--yellow-line:before { background: #ffd54f; }
.active-button--top-line:before,
.active-button--bottom-line:before { height: 2px; left: 0; transform: scaleX(0); width: 100%; }
.active-button--right-line:before,
.active-button--left-line:before { /* height: 100%; transform: scaleY(0); top: 0; width: 2px; */ }
.active-button--top-line:before { top: 0; }
.active-button--right-line:before { right: 0; }
.active-button--bottom-line:before { bottom: 0; }
.active-button--left-line:before { left: 0; }
.active-button--active.active-button--top-line:before,
.active-button--active.active-button--bottom-line:before { transform: scaleX(1); }
.active-button--active.active-button--right-line:before,
.active-button--active.active-button--left-line:before { transform: scaleY(1); }
</style>



// WEBPACK FOOTER //
// src/components/buttons/ActiveButton.vue